import ContactSection from "../components/sections/ContactSection";
import LeadForm from "../components/sections/LeadForm";
import useSEO from "../lib/useSEO";

export default function Iletisim() {
    useSEO({
        title: "İletişim | İstanbul Dövme Silme - Doğuş Çizikoğlu",
        description:
            "Esenyurt İstanbul lokasyonumuza ulaşın. WhatsApp, telefon ve yol tarifi.",
        canonical: "https://www.istanbuldovmesilme.com/iletisim",
    });
    return (
        <>
            <div className="pt-12 pb-0">
                <ContactSection />
            </div>
            <LeadForm />
        </>
    );
}
